/**
 * CareAreaService
 * Service for managing the care area catalog
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for care area catalog CRUD operations
 */
export class CareAreaService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CareAreaService.DEFAULT_SERVICE_PATH,
            basePath: CareAreaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CareAreaService.DEFAULT_SERVICE_PATH = 'ac-counselling';
CareAreaService.BASE_PATH = 'api/care-areas';
//# sourceMappingURL=CareAreaService.js.map